import React from "react";

export function Pill({ label, tone = "neutral" }) {
  return <span className={`sg-pill sg-pill-${tone}`}>{String(label).replace(/_/g, " ")}</span>;
}

export function EmptyState({ title, hint, icon }) {
  return (
    <div style={{ textAlign: "center", padding: "48px 16px", color: "var(--muted)" }}>
      {icon ? <div style={{ fontSize: 36, marginBottom: 10 }}>{icon}</div> : null}
      <div style={{ fontSize: 17, fontWeight: 700, color: "var(--ink)" }}>{title}</div>
      {hint ? <div style={{ fontSize: 13, marginTop: 6 }}>{hint}</div> : null}
    </div>
  );
}

export function Field({ label, error, ...inputProps }) {
  return (
    <div style={{ marginBottom: 12 }}>
      {label ? <label className="sg-label">{label}</label> : null}
      <input className="sg-input" {...inputProps} />
      {error ? <div style={{ color: "var(--danger)", fontSize: 12, marginTop: 4 }}>{error}</div> : null}
    </div>
  );
}

export function TextArea({ label, ...props }) {
  return (
    <div style={{ marginBottom: 12 }}>
      {label ? <label className="sg-label">{label}</label> : null}
      <textarea className="sg-input" style={{ minHeight: 80, resize: "vertical", fontFamily: "inherit" }} {...props} />
    </div>
  );
}

export function Segment({ options, value, onChange, testIdPrefix }) {
  return (
    <div style={{ display: "flex", padding: 4, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: 10, marginBottom: 14 }}>
      {options.map((opt) => {
        const active = value === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => onChange(opt.key)}
            className={`sg-segbtn ${active ? "sg-segbtn-active" : ""}`}
            data-testid={testIdPrefix ? `${testIdPrefix}-${opt.key}` : undefined}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export function ChipRow({ items, value, onChange, testIdPrefix }) {
  return (
    <div className="sg-chip-row">
      {items.map((item) => {
        const active = value === item.key;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.key)}
            className={`sg-chip ${active ? "sg-chip-active" : ""}`}
            data-testid={testIdPrefix ? `${testIdPrefix}-${item.key}` : undefined}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

export function Spinner() {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: 32 }}>
      <div style={{
        width: 28, height: 28, border: "3px solid var(--line)",
        borderTopColor: "var(--brand)", borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export function Modal({ open, onClose, title, children }) {
  if (!open) return null;
  return (
    <div className="sg-modal-bg" onClick={onClose}>
      <div className="sg-modal-card" onClick={(e) => e.stopPropagation()}>
        {title ? <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 14px" }}>{title}</h3> : null}
        {children}
      </div>
    </div>
  );
}
